/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCompletionPanel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M8 16H6v-2h2zm5-4H6v-2h7zm-3-4H6V6h4z" />
        <path d="M22 22H2V2h20zM4 20h2.385c1.139-2.08 3.315-4 5.948-4 .19 0 .377.015.56.042a8.75 8.75 0 0 1 1.084-1.573c1.19-1.373 2.91-2.469 4.89-2.469a3.7 3.7 0 0 1 1.133.175V4H4zm8.148-1.994c-1.258.072-2.485.87-3.377 1.994h3.273a6.084 6.084 0 0 1-.044-.717c0-.42.052-.848.147-1.277zM18.866 14c-1.22 0-2.433.689-3.377 1.778C14.541 16.873 14 18.22 14 19.283c0 .246.022.485.064.717H20v-5.57a1.69 1.69 0 0 0-1.134-.43z" />
      </g>
    </g>
  </Icon>
);
export { SvgCompletionPanel as CompletionPanel };
